export const Cons = {
  INSTITUTE: "INSTITUTE",
};
export const FILE_URL = "https://api.elibrary.pustakvari.com/uploads/";
// export const FILE_URL = "http://ebook.prometteur.in:5050/uploads/";
// export const FILE_URL = "https://api.ebook.prometteur.in/uploads/";
